import React from 'react';
import { IS_B2B } from '@config';
import PropTypes from 'prop-types';
import Text from '@text';

import './styles.scss';

const StockCounter = ({ stockCount }) => {
  if (!IS_B2B) {
    return null;
  }

  return (
    <span className="ts-bold stock-counter">
      <Text>pdp.product.stockcount</Text> <span className="ts-bold count">{stockCount <= 499 ? stockCount : '499+'}</span>
    </span>
  );
};

StockCounter.propTypes = {
  stockCount: PropTypes.string,
};

export default StockCounter;
